@if (view && response) {
  @switch (view.type) {
    @case ("SURVEY_PAGE") {
      <app-survey-page
        [previewMode]="PreviewMode.FreeFlow"
        [response]="response"
      ></app-survey-page>
    }
  }
}
